import get from 'lodash/get';

import BrowseItem from './BrowseItem';
import BrowseSection from './BrowseSection';

export function parseTopLevelData(topLevelData) {
  const topLevelSections = get(topLevelData, 'sections');

  const sections = [];
  topLevelSections.forEach(topLevelSection => {
    const section = {};
    section.id = get(topLevelSection, 'id');
    section.title = get(topLevelSection, 'title.labels[0].text');
    section.viewAll = get(topLevelSection, 'viewAll.labels[0].text');
    section.viewAllAnalyticsToken = get(topLevelSection, 'viewAll.analyticsToken');
    section.webUrl = get(topLevelSection, 'viewAll.webUrl');
    section.sectionId = get(topLevelSection, 'subsections[0].sectionId');
    section.items = createListOfItems(parseItemData(get(topLevelSection, 'subsections[0].items')));
    if (!section.items.length) {
      // filter out sections with no items
      return;
    }
    sections.push(section);
  });

  return sections;
}

export function parseDeepLevelData(deepLevelData) {
  const section = {};
  const directorySubsections = get(deepLevelData, 'sections');
  section.webUrl = get(deepLevelData, 'webUrl');
  section.numOfSubsections = directorySubsections.length;
  const unparsedItems = get(deepLevelData, 'sections[0].subsections[0].items');
  if (directorySubsections.length > 1) {
    // In the event that a deep level has multiple subsections (e.g. New Music and Podcasts)
    section.subsections = createListOfSubsections(parseSubsectionData(directorySubsections));
  } else {
    section.id = get(deepLevelData, 'sections[0].id');
    section.title = get(deepLevelData, 'sections[0].title.labels[0].text');
    section.title = section.title || get(deepLevelData, 'title');
    section.webUrl = get(deepLevelData, 'webUrl');
    section.sectionId = get(deepLevelData, 'sections[0].subsections[0].sectionId');
    section.totalItems = get(deepLevelData, 'sections[0].subsections[0].totalItems');
    if (section.totalItems) {
      // Deep level with one directory of pagination
      section.items = createLargeListOfItems(
        unparsedItems,
        section.totalItems,
        unparsedItems.length,
      );
      section.currentCount = unparsedItems.length;
      section.fetchedPages = [];
      section.fetchedPages.push(1); // First page is loaded on initial load
      section.totalPages = Math.ceil(section.totalItems / unparsedItems.length);
    } else {
      section.items = createListOfItems(
        parseItemData(get(deepLevelData, 'sections[0].subsections[0].items')),
      );
    }
  }
  return section;
}

export function parseAppendedSectionData(appendData, oldSection, offset, pageToAdd) {
  oldSection.fetchedPages.push(pageToAdd);
  const unparsedItems = get(appendData, 'sections[0].subsections[0].items');
  const listOfItems = oldSection.items;
  const parsedNewItems = createListOfItems(parseItemData(unparsedItems));
  let z = offset;
  parsedNewItems.forEach(item => {
    listOfItems[z] = item;
    z++;
  });
  return listOfItems;
}

function parseSubsectionData(directoryData) {
  const subsections = [];
  directoryData.forEach(subsection => {
    const section = {};
    section.id = get(subsection, 'id');
    section.title = get(subsection, 'title.labels[0].text');
    section.webUrl = get(subsection, 'webUrl');
    section.sectionId = get(subsection, 'subsections[0].sectionId');
    section.totalItems = get(subsection, 'subsections[0].totalItems');
    const unparsedItems = get(subsection, 'subsections[0].items');
    if (section.totalItems) {
      section.items = createLargeListOfItems(
        unparsedItems,
        section.totalItems,
        unparsedItems.length,
      );
      section.currentCount = unparsedItems.length;
      section.fetchedPages = [];
      section.fetchedPages.push(1); // First page is loaded on initial load
      section.totalPages = Math.ceil(section.totalItems / unparsedItems.length);
    } else {
      section.items = createListOfItems(parseItemData(unparsedItems));
    }
    subsections.push(section);
  });
  return subsections;
}

function createLargeListOfItems(items, totalItems, numOfItemsFromServer) {
  const parsedItems = parseItemData(items);
  let finalItems = [];
  finalItems = createListOfItems(parsedItems);
  // Create placeholders for all of the rest of the items
  for (let i = numOfItemsFromServer; i < totalItems; i++) {
    finalItems.push(new BrowseItem({ key: i, isBlank: true }));
  }

  return finalItems;
}

function createListOfSubsections(subsections) {
  return subsections.map(props => new BrowseSection(props));
}

function createListOfItems(sectionItems) {
  return sectionItems.map(props => new BrowseItem(props));
}

export function parseItemData(sectionItems = []) {
  const items = [];
  sectionItems.forEach(sectionItem => {
    const item = {};
    item.pandoraId = get(sectionItem, 'pandoraId');
    item.stationFactory = get(sectionItem, 'stationFactory');
    item.key = item.pandoraId;
    item.webUrl = get(sectionItem, 'webUrl');
    item.analyticsToken = get(sectionItem, 'analyticsToken');
    item.hoverText = get(sectionItem, 'hoverText');
    item.firstLineText = get(sectionItem, 'labels[0].text');
    item.secondLineText = get(sectionItem, 'labels[1].text');
    item.thirdLineText = get(sectionItem, 'labels[2].text');
    item.artId = get(sectionItem, 'image.artId');
    item.fullUrl = get(sectionItem, 'image.fullUrl');
    item.isCircular = get(sectionItem, 'image.circular');
    items.push(item);
  });

  return items;
}
